var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablePropertyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    stroke: "#E9E9E9",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.25C7 7.55964 7.55964 7 8.25 7H15.75C16.4404 7 17 7.55964 17 8.25V15.75C17 16.4404 16.4404 17 15.75 17H8.25C7.55964 17 7 16.4404 7 15.75V8.25ZM16.375 9.5H13.875V11.375H16.375V9.5ZM16.375 12H13.875V13.875H16.375V12ZM16.375 14.5H13.875V16.375H15.75C16.0952 16.375 16.375 16.0952 16.375 15.75V14.5ZM13.25 16.375V14.5H10.75V16.375H13.25ZM10.125 16.375V14.5H7.625V15.75C7.625 16.0952 7.90482 16.375 8.25 16.375H10.125ZM7.625 13.875H10.125V12H7.625V13.875ZM7.625 11.375H10.125V9.5H7.625V11.375ZM10.75 9.5V11.375H13.25V9.5H10.75ZM13.25 12H10.75V13.875H13.25V12Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablePropertyIcon);
export default __webpack_public_path__ + "static/media/tablePropertyIcon.a85cb74bda66bde72874c1ce3643508c.svg";
export { ForwardRef as ReactComponent };